import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldGrid, FieldItem } from "./GeneralDashboardFieldGrid";
import { GeneralDashboardComplex } from "../api/generalDashboard/generalDashboard.types";

interface GeneralComplexCardProps {
  data: GeneralDashboardComplex | null;
  onMenuClick: () => void;
}

export const GeneralComplexCard: React.FC<GeneralComplexCardProps> = ({
  data,
  onMenuClick,
}) => {
  const { translate } = useLocalization();

  const fields: FieldItem[] = [
    {
      labelKey: "general.dashboard.complex.name",
      value: data?.name,
    },
    {
      labelKey: "general.dashboard.complex.cnpj",
      value: data?.cnpj,
    },
    {
      labelKey: "general.dashboard.complex.cep",
      value: data?.address?.zipCode,
    },
    {
      labelKey: "general.dashboard.complex.responsibleName",
      value: data?.responsible?.name,
    },
  ];

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.complex.title")}
      titleVariant="hidden"
      onMenuClick={onMenuClick}
      menuTestId="more-options-complexo"
      padding="compact"
    >
      <GeneralDashboardFieldGrid fields={fields} variant="identity" />
    </GeneralDashboardCard>
  );
};
